export enum BypLtddProductsExperimentEnum {
  OriginalShowLtddProducts = "0",
  HideLtddProducts = "1"
}
